import {GET_OWNER_APPLICATION,GET_SUBSCRIPTION_INFO,GET_OWNER_IP_LIST,GET_OWNER_RENTAL_CONTRACT, GET_ALL_PROP_OWNER ,GET_OWNER_DETAILS,GET_OWNER_PROPERTIES,GET_OWNER_PROPERTIES_ADS,GET_OWNER_REPORTED_PROPERTIES,GET_OWNER_SUBSCRIPTION_INFO} from "./actions";

const initialState = {
  propOwner: {
    docs: [],
    totalDocs: 0,
    limit: 10,
    page: 1,
    totalPages: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: null,
    nextPage: null,
  },
  ownerProperties:{
    docs: [],
    totalDocs: 0,
    limit: 10,
    page: 1,
    totalPages: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: null,
    nextPage: null,
  },
  ownerAds:{
    docs: [],
    totalDocs: 0,
    limit: 10,
    page: 1,
    totalPages: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: null,
    nextPage: null,
  },
  ownerReportedProperties:{
    docs: [],
    totalDocs: 0,
    limit: 10,
    page: 1,
    totalPages: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: null,
    nextPage: null,
  },
  ownerSubscriptionInfo:{
    docs: [],
    totalDocs: 0,
    limit: 10,
    page: 1,
    totalPages: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: null,
    nextPage: null,
  },
  ownerApplication:{
    docs: [],
    totalDocs: 0,
    limit: 10,
    page: 1,
    totalPages: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: null,
    nextPage: null,
  },
  ownerRentalContract:{
    docs: [],
    totalDocs: 0,
    limit: 10,
    page: 1,
    totalPages: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: null,
    nextPage: null, 
  },
  ownerIpList:{
    docs: [],
    totalDocs: 0,
    limit: 10,
    page: 1,
    totalPages: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: null,
    nextPage: null,   
  },
  propertyData:{},
  subscriptionInfo:{},
  loading:true,
};

const propertyOwnerReducer = (state=initialState,{type,payload})=>{
    switch(type){
        case GET_ALL_PROP_OWNER:
            return {
                ...state,
                loading:false,
                propOwner:payload,
                
            };
        case GET_OWNER_DETAILS:
          return {
            ...state,
            loading:false,
            propertyData:payload,
          };
        case GET_OWNER_PROPERTIES:
          return {
            ...state,
            loading:false,
            ownerProperties:payload,
          };
        case GET_OWNER_PROPERTIES_ADS:
          return {
            ...state,      
            ownerAds:payload,
          };
        case GET_OWNER_REPORTED_PROPERTIES:
          return {
            ...state,      
            ownerReportedProperties:payload,
          }; 
        case GET_OWNER_SUBSCRIPTION_INFO:
          return {
            ...state,      
            ownerSubscriptionInfo:payload,
          };  
        case GET_OWNER_APPLICATION:
          return {
            ...state,      
            ownerApplication:payload,
          };  
        case GET_OWNER_RENTAL_CONTRACT:
          return {
            ...state,
            ownerRentalContract:payload
          }
        case GET_OWNER_IP_LIST:
          return {
            ...state,
            ownerIpList:payload
          }
        case GET_SUBSCRIPTION_INFO:
          return{
            ...state,
            subscriptionInfo:payload
          }
        default:
            return state;
    }
}

export default propertyOwnerReducer;

